import { useEffect, useRef } from 'react';
import useSocket from './useSocket';

export default function useSocketSubscription(resource, resourceIds = null, requiredResources = false) {
  console.log('[useSocketSubscription] resource', resource, resourceIds, requiredResources);
  const { socket, connectionState } = useSocket();
  const isConnected = connectionState.status === 'connected';
  const previousResourceIds = useRef(null);

  useEffect(() => {
    console.log('[useSocketSubscription] Connection state:', connectionState);
    if (!isConnected || !resource) return;
    if (requiredResources && resourceIds === null) return;

    // If we have previous IDs, unsubscribe from the ones that are no longer present
    if (previousResourceIds.current) {
      const removedIds = previousResourceIds.current.filter(id => 
        !resourceIds || !resourceIds.includes(id)
      );
      if (removedIds.length > 0) {
        socket.unsubscribeFromResource(resource, removedIds);
      }
    }

    // Subscribe to new IDs
    if (resourceIds) {
      const newIds = resourceIds.filter(id => 
        !previousResourceIds.current || !previousResourceIds.current.includes(id)
      );
      if (newIds.length > 0) {
        socket.subscribeToResource(resource, newIds);
      }
    } else {
      socket.subscribeToResource(resource);
    }

    // Update previous IDs
    previousResourceIds.current = resourceIds;

    // Cleanup: unsubscribe from all IDs when component unmounts
  }, [socket, isConnected, resource, resourceIds, requiredResources]);

  useEffect(() => {
    return () => {
      if (!socket || !resource) return;
      
      if (previousResourceIds.current) {
        socket.unsubscribeFromResource(resource, previousResourceIds.current);
      } else {
        socket.unsubscribeFromResource(resource);
      }
    };
  }, [socket, resource]);

  return isConnected;
}
